import React, { useState } from 'react';
import { PaymentSummaryModal } from '@nile/client_management/src/Pages/Invoice/PaymentSummaryModal';
import { SVGIcon } from '@superops/super-icons';

export function PaymentSummaryCell(props) {
  const [open, setOpen] = useState(false);
  const data = props.cell.row.original; // transactions
  const hasTransactions =
    (Number(data?.amountDue) === 0 || data?.partiallyPaid) &&
    Number(data?.totalAmount) !== 0;
  return (
    <>
      {open && (
        <PaymentSummaryModal
          open
          onClose={() => setOpen(false)}
          displayId={data.displayId}
          invoiceId={data.invoiceId}
        />
      )}
      <div
        onClick={() => {
          if (!hasTransactions) return;
          setOpen(true);
        }}
        className={`flex items-center ${
          hasTransactions ? 'cursor-pointer' : 'disable-actions'
        }`}
      >
        <SVGIcon name="Info" />
      </div>
    </>
  );
}
